import { ListGroup as ListGroupUI } from "@cc/react-components";
import { IconType } from "components/Icon/IconType";
import React, { FC, HTMLAttributes } from "react";
import cn from "classnames";

interface ListGroupProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Sets whether to render the list group horizontal or not
   */
  horizontal?: boolean;
}

interface ListGroupItemProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Sets list item as active.
   */
  active?: boolean;
  /**
   * Sets list item state as disabled.
   */
  disabled?: boolean;
  /**
   * Sets the visual variant.
   */
  variant?:
    | "primary"
    | "secondary"
    | "success"
    | "danger"
    | "warning"
    | "info"
    | "dark"
    | "light"
    | "flush";
  /**
   * Providing a `href` will render an `<a>` element, styled as a button.
   */
  href?: string;
  /**
   * Triggered when the button is clicked.
   */
  onClick?: () => void;
  /** Sets an icon to display */
  icon?: IconType | "";
}

const ListGroup: FC<ListGroupProps> & {
  Item: FC<ListGroupItemProps>;
  ItemMobile: FC<ListGroupItemProps>;
} = ({ ...others }: ListGroupProps) => (
  // @ts-ignore
  <ListGroupUI {...others} />
);

ListGroup.Item = ({ ...props }: ListGroupItemProps) => (
  // @ts-ignore
  <ListGroupUI.Item {...props} />
);

ListGroup.ItemMobile = ({ className, ...props }: ListGroupItemProps) => (
  // @ts-ignore
  <ListGroupUI.Item
    className={cn("text-center", "font-weight-bold", "p-4", className)}
    {...props}
  />
);

export default ListGroup;
